// extracted by mini-css-extract-plugin
export default {"cover":"CoverImage--cover--uljb9"};